'use client'

// React Imports
import { useEffect, useRef } from 'react'

// Third-party Imports

// Type Imports

import type { Theme } from '@mui/material/styles'

import { useMediaQuery } from '@mui/material'

// Hook Imports
import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@menu/hooks/useVerticalNav'

const Logo = ({}: {}) => {
  // Refs
  const logoTextRef = useRef<HTMLSpanElement>(null)

  // Hooks
  const { isHovered } = useVerticalNav()
  const { settings } = useSettings()

  // Vars
  const { layout } = settings
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  useEffect(() => {
    if (layout !== 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current.classList.remove('hidden')
      }

      return
    }

    if (logoTextRef && logoTextRef.current) {
      if (layout === 'collapsed' && !isHovered) {
        logoTextRef.current?.classList.add('hidden')
      } else {
        logoTextRef.current.classList.remove('hidden')
      }
    }
  }, [isHovered, layout])
  useEffect(() => {
    if (layout == 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current?.classList.add('hidden')
      }
    }
  }, [logoTextRef.current, layout])

  return (
    <div className='flex items-center min-bs-[24px]'>
      <img src='/images/icon/logo_white.png' alt='logo' width={isMobile ? 60 : 100} height={isMobile ? 35 : 65} />
    </div>
  )
}

export default Logo
